import React, { useEffect, useState } from "react";
import "./home.less";
import { FZSJ } from "./FZSJ";
import { FX } from "./FX";
import Radio from "antd/lib/radio";
import { Select, Tree } from "antd";
import zoomImg from "../../assets/zoom.png";
import { FWL } from "./FWL";
import { GLDWZJ } from "./GLDWZJ";
import useGlobalModel from "@/model/globalModel";
import { useHomerModal } from "./homeModel";
import { DataNode, EventDataNode } from "antd/lib/tree";
import { IDictDetail } from "../base/dict/dictService";

export function Home() {
    const { orgDs } = useGlobalModel();
    const { loading, visitData, shareData, orgInsertData, groupInsertData, employeeValue, employeeData,
        loadVisit, loadShare, loadOrgInsert, loadGroupInsert, loadData, handleEmployee, type, setType } = useHomerModal();
    const [selectedNodes, setSelectedNodes] = useState<any[]>([]);   //树选中的行信息
    const [zoomInfo, setZoomInfo] = useState<any>({
        fx: false,
        fwl: false,
        fzsj: false,
        gldwzj: false
    });

    const handleZoom = (str: string) => {
        setZoomInfo({
            fx: false,
            fwl: false,
            fzsj: false,
            gldwzj: false,
            [str]: !zoomInfo[str]
        })
    }
    useEffect(() => {
        if (orgDs.length) {
            loadData('monthly', orgDs[0]?.key);
            setSelectedNodes(orgDs)
        }
    }, [orgDs]);

    const onChange = (e: any) => {
        let value = e.target.value;
        setType(value)
        loadData(value, selectedNodes[0]?.key);
    }

    //管理公司选中事件
    const onSelect = (selectedKeys: React.Key[], info: {
        event: "select";
        selected: boolean;
        node: EventDataNode;
        selectedNodes: DataNode[];
        nativeEvent: MouseEvent;
    }) => {
        let selectNode = info.selectedNodes as IDictDetail[];
        if (selectNode.length) {
            loadVisit(type, selectNode[0]?.key);
            loadShare(type, selectNode[0]?.key);
            setSelectedNodes(selectNode);
        }
    };

    return (
        <div className="home-container">
            <Radio.Group defaultValue={type} buttonStyle="solid" onChange={onChange}>
                <Radio.Button value="monthly">本月</Radio.Button>
                <Radio.Button value="quarterly">季度</Radio.Button>
                <Radio.Button value="yearly">年度</Radio.Button>
            </Radio.Group>

            <div className="top-wrap">
                <div className="left">
                    <div className="title">管理公司</div>
                    <div className="content">
                        {selectedNodes.length > 0 && <Tree
                            defaultExpandedKeys={[orgDs[0]?.key]}
                            selectedKeys={[selectedNodes[0]?.key]}
                            onSelect={onSelect}
                            treeData={orgDs}
                        />}
                    </div>
                </div>
                {!zoomInfo.fwl && <div className={`middle ${zoomInfo.fx ? 'fixed_win' : ''}`}>
                    <div className="head">
                        <div className="title">
                            分享
                            <span>单位（次）</span>
                        </div>
                        <div>
                            <Select
                                value={employeeValue}
                                placeholder="人员"
                                showSearch={true}
                                optionFilterProp="label"
                                style={{ width: '140px', minHeight: '28px' }}
                                options={employeeData}
                                onSelect={(value: string) => handleEmployee(value)}
                            />
                            <img src={zoomImg} className="qr" onClick={() => handleZoom('fx')} />
                        </div>
                    </div>
                    <div className="echart-box">
                        <FX data={shareData} />
                    </div>
                </div>}
                {!zoomInfo.fx && <div className={`right ${zoomInfo.fwl ? 'fixed_win' : ''}`}>
                    <div className="head">
                        <div className="title">
                            访问量
                            <span>单位（次）</span>
                        </div>
                        <div>
                            <img src={zoomImg} className="qr" onClick={() => handleZoom('fwl')} />
                        </div>
                    </div>
                    <div className="echart-box">
                        <FWL data={visitData} />
                    </div>
                </div>}
            </div>

            <div className="bottom-wrap">
                {!zoomInfo.gldwzj && <div className={`left ${zoomInfo.fzsj ? 'fixed_win' : ''}`}>
                    <div className="head">
                        <div className="title">
                            分组数据
                        </div>
                        <div>
                            <img src={zoomImg} className="qr" onClick={() => handleZoom('fzsj')} />
                        </div>
                    </div>
                    <div className="echart-box">
                        <FZSJ data={groupInsertData} />
                    </div>
                </div>}
                {!zoomInfo.fzsj && <div className={`right ${zoomInfo.gldwzj ? 'fixed_win' : ''}`}>
                    <div className="head">
                        <div className="title">
                            管理公司增加次数
                            <span>单位（次）</span>
                        </div>
                        <div>
                            <img src={zoomImg} className="qr" onClick={() => handleZoom('gldwzj')} />
                        </div>
                    </div>
                    <div className="echart-box">
                        <GLDWZJ data={orgInsertData} />
                    </div>
                </div>}
            </div>
        </div>
    )
}  